import React from "react";
import Config from "./config";
import axios from 'util/Api'

const getRemoteJSON = async (endpoint="") => {
    let respData = [];

    // await axios.get(Config.apiserver+endpoint)
    //     .then((res) => {
    //         //console.log(res.data);
    //         respData = res.data.data;
    //     })
    //     .catch((error) => {
    //         console.log(error);
    //         // setState([]);
    //     });


    const getData = async () => {
        return await axios.get(Config.apiserver+endpoint)
            .then((res) => {
                //console.log(res.data);
                respData = res.data.data;
            })
            .catch((error) => {
                console.log(error);
                // setState([]);
            });
    };

    getData();

    return respData;

}

export default getRemoteJSON;